import classnames from 'classnames';

import { Text } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Divider from 'src/components/ResumeCard/Divider';
import translation from 'src/components/translation';
import type { PreferredContact } from 'src/models/resume/resumeCommon.types';
import type { Phone } from 'src/models/resumeCard';
import { ELLIPSIS } from 'src/utils/constants/symbols';

import VerifiedPhoneIcon from 'src/components/ResumeCard/Body/Contacts/Phone/VerifiedPhoneIcon';

const TrlKeys = {
    preferred: 'rb.view.preferredcontact',
};

const getCroppedPhone = (phone: string) => `${phone.substring(0, 10)}${ELLIPSIS}`;
const checkPreferredPhone = (phone: Phone, preferredPhone?: PreferredContact) =>
    preferredPhone === `${phone.type}_phone`;

interface Props {
    phone: Phone;
    preferredPhone?: PreferredContact;
    isOpenContacts?: boolean;
}

const ContactsPhone: TranslatedComponent<Props> = ({ phone, preferredPhone, isOpenContacts, trls }) => {
    const isPreferred = checkPreferredPhone(phone, preferredPhone);
    return (
        <span>
            {phone.verified && <VerifiedPhoneIcon />}
            <Text
                Element="span"
                typography={isPreferred ? 'subtitle-2-semibold' : 'label-3-regular'}
                data-qa={classnames('resume-phone', { 'resume-contact-preferred': isPreferred })}
            >
                {isOpenContacts ? phone.formatted : getCroppedPhone(phone.formatted)}
            </Text>
            {isOpenContacts && (
                <>
                    {phone.comment && (
                        <>
                            <Divider />
                            <span data-qa="resume-phone-description">{phone.comment}</span>
                        </>
                    )}
                    {isPreferred && (
                        <>
                            <Divider />
                            <span>{trls[TrlKeys.preferred]}</span>
                        </>
                    )}
                </>
            )}
        </span>
    );
};

export default translation(ContactsPhone);
